import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import { Grid, LinearProgress, Paper, Tooltip, Typography} from '@mui/material';

import HelpOutline from '@mui/icons-material/HelpOutline';

const abEnvironment = new AbEnvironment();
const FloatBalanceTileQuery = graphql`
query FloatBalanceTileQuery($accountId: UUID!) {
  getfloatbalance(accountid: $accountId)
}
`;

const styleSheet = theme => ({
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 212
  },
  dbTile2: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 184
  },
  lp1: {
    height: 12,
    width: 204
  },
  lp2: {
    height: 12,
    width: 176
  }
});
  
class FloatBalanceTile extends Component {

  render() {
    const classes = this.props.classes;

    let theTileClass = classes.dbTile;
    let theLpClass   = classes.lp1;
    if (this.props.narrow === true) {
      theTileClass = classes.dbTile2;
      theLpClass   = classes.lp2;
    }

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={FloatBalanceTileQuery}
        variables={{accountId: this.props.accountId}}
        render={({error, props})=> {

          if (error) {
            return <div>{error.message}</div>
          } else if (props) {
            let percentBalanceUsed = 0;
            let floatBalanceDisplay = '';
            let floatLimitDisplay = '';
            if (props.getfloatbalance) {
              let theFloatBalance = props.getfloatbalance;
              if (theFloatBalance < 0) {
                theFloatBalance = 0;
              }

              let theFloatLimit = this.props.floatLimit;

              let balanceUsed = 0;
              if (theFloatLimit != 0) {
                balanceUsed = theFloatBalance / theFloatLimit;
              }

              //since balance used is a decimal, multiply by 100 and round to nearest whole number
              balanceUsed = balanceUsed * 100;
              percentBalanceUsed = Math.round(balanceUsed);

              floatBalanceDisplay = Number(theFloatBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              floatLimitDisplay = Number((theFloatLimit)).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
            }

            let floatLimitTitle = "Overdraft (" + percentBalanceUsed + "% of limit)";
            let floatLimitTt = "We may provide your customer with an overdraft float for purchasing subscriptions.  This, plus your customer's topup balance, is the amount available for purchasing subscriptions.  We track the current overdraft float for all subscriptions that you've provisioned for your customer.  Each individual charge typically clears within a few days, but if you provision a large number of subscriptions and your customer is not funding a top up balance, they may need a higher overdraft limit."

            return (
              <Grid item>
                <Paper className={theTileClass}>
                  <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                    <Grid item style={{marginBottom: '-3px'}}>
                      <Typography variant="h6">{floatBalanceDisplay} / <sub>{floatLimitDisplay}</sub></Typography>
                    </Grid>
                    <Grid item>
                      <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                        <Grid item>
                          <Typography variant="body2" align="center">{floatLimitTitle}</Typography>
                        </Grid>
                        <Grid>
                          <Tooltip placement='bottom' title={floatLimitTt}>
                            <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid>
                      <LinearProgress variant="buffer" value={percentBalanceUsed} className={theLpClass}
                                      valueBuffer={100} color="secondary" />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            );
          }
        }}
      />
    );
  }
}

export default withStyles(styleSheet)(FloatBalanceTile);